module.exports = __webpack_public_path__ + "img/girl-sms.fce8e20.svg";